import {Style, Fill, Stroke, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class CwaLayer extends GeoJsonLayer {

    hazards = [ 'conv', 'turb', 'icing', 'ifr'];

    constructor( map, settings = {} ){
        settings["name"] = 'cwa';
        settings["dynamic_time"] = true;
        settings["dynamic_level"] = true;
        settings["api_endpt"] = "CwaJSON.php";
        if( settings.opacity == undefined ) settings['opacity'] = .5;
        if( settings.hazards == undefined ) settings['hazards'] = "all";
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "hazards", this.settings['hazards']);
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        if( this.map.init_secs != undefined )
            url.searchParams.set( "now_date", Library.formatDate( "ymd_hn", this.map.init_secs ));
        return url.toString();
    }

    getColor( feature ){
        if( this.property(feature,'hazard') == "ICE" )
            return "#000080";
        if( this.property(feature,'hazard') == "TURB" )
            return "#A06000";
        if( this.property(feature,'hazard') == "IFR" )
            return "#800080";
        if( this.property(feature,'hazard') == "PCPN" )
            return "#800080";
        return "#800000";
    }

    getLineColor( feature ){
        return "#000000";
    }

    getHighlightColor( feature ){
        return "#CCCCCC";
    }

    getLabel( feature ){
        return this.property(feature,'hazard')
    }

    getOpacity(feature){
        return this.settings['opacity'];
    }

    getStyle(feature, resolution ){
        let style = new Style({
                "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getColor(feature), 
                                this.settings['opacity'])
                        }),
                "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getLineColor(feature), 0.5),
                        "width": 2
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray("#800000")
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 })
                        })

                });
        return style;
    }

    getPopupText( feature ){
        let text = this.popupTitle( "CWA", this.property(feature,'hazard'));
        text += this.popupData( "CWSU", this.property(feature,'cwsu')+
            " ["+this.property(feature,'name')+"] "+ this.property(feature,'series_id'));
        text += this.popupData( "Hazard", this.property(feature,'hazard') + " - " + this.property(feature,'qualifier') );
        text += this.popupData( "Begins", this.property(feature,'valid_time_from') );
        text += this.popupData( "Ends", this.property(feature,'valid_time_to') );
        if( this.property(feature,'top') != undefined )
            text += this.popupData( "Top", this.property(feature,'top') + " ft" );
        if( this.property(feature,'base') != undefined )
            text += this.popupData( "Base",this.property(feature,'base') + " ft" );
        if( this.property(feature,'dir') != undefined ){
            if( this.property(feature,'spd') == "UNK" )
                text += this.popupData( "Movement", "unknown" );
            else if( this.property(feature,'spd') == 0 )
                text += this.popupData( "Movement", "stationary" );
            else
                text += this.popupData( "Movement", this.property(feature,'dir') + " deg at " + this.property(feature,'spd') + " kt" );
        }
        text += this.popupSep();
        let cwa = this.property(feature,'cwa_text');
        cwa = cwa.replace( /\n/g, "<br/>" );
        text += this.popupData( "", cwa );
        text += this.popupEnd();
        return text;
    }

    setHazards(val, refresh = true){
        if( val == undefined ){
            let params = [];
            for( let i = 0; i < this.hazards.length; i++ ){
                if( Library.getCheckbox( "check_cwa_hazards_"+this.hazards[i] )){
                    params.push( this.hazards[i]);
                }
            }
            this.settings['hazards'] = params.join(",");
        } else {
            let params = val.split(",");
            if( params[0] == "all" ){
                for( let i = 0; i < this.hazards.length; i++ )
                    Library.setCheckbox( "check_cwa_hazards_"+this.hazards[i], true );
            } else {
                for( let i = 0; i < this.hazards.length; i++ )
                    Library.setCheckbox( "check_cwa_hazards_"+this.hazards[i], false );
            }
            for( let i = 0; i < params.length; i++ )
                Library.setCheckbox( "check_cwa_hazards_"+params[i], true );

            this.settings['hazards'] = val;
        }
        if( refresh ){
            this.refresh();
        }
    }
    
    setOpacity( val ){
        this.settings['opacity'] = Number(val);
        this.refresh();
        return 1;
    }

    updateLevel(){
        this.refresh();
    }
    
    updateTime(){
        this.refresh();
    }
}
